import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "../../styles/Header-css/ServicePartner/Servicepartner.css";
import logo_0 from "../../../assets/images/R2R.png";
import { FaUser } from "react-icons/fa";
import OtpPopup from "./OtpPopup";
import PartnerVerfication from "./PartnerVerification/PartnerVerification";
import { auth, generateRecaptcha } from "../../../firebase/config";
import { signInWithPhoneNumber } from "firebase/auth";
// 🔥 imported API file
import { loginWithFirebase } from "../../../api/auth/authApi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth/useAuth";
const Servicepartner = () => {
  const [notification, setNotification] = useState({ message: "", type: "" });
  const [formData, setFormData] = useState({ number: "", agreed: false });
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showProfileSetup, setShowProfileSetup] = useState(false);
  const [partnerProfile, setPartnerProfile] = useState(null);
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();
  // ✅ REQUIRED — THIS FIXES YOUR ERRORS
  const [confirmationResult, setConfirmationResult] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("partnerProfile");
    if (stored) {
      setPartnerProfile(JSON.parse(stored));
    }
  }, []);

  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification({ message: "", type: "" }), 3000);
  };

  const handleRegister = async () => {
    const { number, agreed } = formData;
    const isValid = number.trim() && agreed;

    if (!isValid) {
      showNotification("Please enter your phone number and agree to the terms.", "error");
      return;
    }

    try {
      const recaptchaVerifier = generateRecaptcha();
      const phoneNumber = `+91${number}`;
      console.log(`Sending OTP to ${phoneNumber}...`);

      const result = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
      setConfirmationResult(result); // uses the FIXED state
      setShowOtpPopup(true);

    } catch (error) {
      console.error("Error sending OTP:", error);
      showNotification("Failed to send OTP. Please try again.", "error");
    }
  };

  /** 🔥 VERIFY OTP + CALL BACKEND LOGIN API */
  const handleOtpSubmit = async (otp) => {
    try {
      if (!confirmationResult) {
        showNotification("OTP session expired. Please try again.", "error");
        return;
      }

      const result = await confirmationResult.confirm(otp);
      const idToken = await result.user.getIdToken();

      setToken(idToken);
      setShowOtpPopup(false);
      setShowProfileSetup(true);
      // for partner app use "partner", for customer app use "customer"
        const res = await loginWithFirebase(idToken, "p"); 
     // set global auth
      login({ userId: res.userId, role: res.role, token: idToken });
    localStorage.setItem("user_id", res.userId);
    localStorage.setItem("role", res.role);
    console.log(res);
     if (res.role === "p") {
     switch (res.onboardingStep) {
          case "profile": return navigate("/partner/onboarding?step=0");
          case "skills": return navigate("/partner/onboarding?step=1");
          case "kyc": return navigate("/partner/onboarding?step=2");
          case "worklocation": return navigate("/partner/onboarding?step=3");
          case "verification": return navigate("/partner/onboarding?step=4");
          case "onboarding": return navigate("/partner/onboarding?step=5");
          case "complete": return navigate("/partner-profile");
          default: return navigate("/partner-profile");
        }
      } else if (res.role === "customer") {
        if (!res.has_name || !res.has_primary_address) return navigate("/customer/onboarding");
        return navigate("/customer/dashboard");
      } else if (res.role === "admin") {
        return navigate("/admin/dashboard");
      } else if (res.role === "employee") {
        return navigate("/employee/dashboard");
      } 
      else {
        showNotification("Role not supported", "error");
       }

    } catch (error) {
      console.error("OTP verify error:", error);
      showNotification("Invalid OTP. Please try again.", "error");
    }
  };

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  // PAGE REDIRECT TO PROFILE SETUP
  // if (showProfileSetup) {
  //   return (
  //     <PartnerVerfication
  //       onComplete={(profile) => {
  //         localStorage.setItem("partnerProfile", JSON.stringify(profile));
  //         setPartnerProfile(profile);
  //         setShowProfileSetup(false);
  //         showNotification("Onboarding complete!", "success");
  //       }}
  //     />
  //   );
  // }

  return (
    <div className="service-partner-page">
      <div id="recaptcha-container"></div>

      <div className="page-wrapper">

        {notification.message && (
          <div className={`popup-notification ${notification.type}`}>
            <p>{notification.message}</p>
          </div>
        )}

        {showOtpPopup && (
          <OtpPopup
            phoneNumber={formData.number}
            onClose={() => setShowOtpPopup(false)}
            onSubmit={handleOtpSubmit}
          />
        )}

        <header className="header">
          <div className="header-container">
            <div className="header-left">
              <img src={logo_0} className="header-logo" alt="R2R Logo" />
              <span className="header-title">Ready2Rental</span>
            </div>

            <nav className="header-right">
              <Link to="/book-service" className="nav-btn primary">
                Book a service
              </Link>
              <Link to="/about" className="nav-btn secondary">
                About us
              </Link>
              <div className="profile-icon">
                <Link to="/partner-profile">
                  <FaUser />
                </Link>
              </div>
            </nav>
          </div>
        </header>

        <main className="service-partner-container">
          <div className="form-section">
            <h2>Become a Partner</h2>
            <p className="form-subtitle">Join our network of skilled professionals.</p>

            <div className="input-group phone-input">
              <span className="country-code">🇮🇳 +91</span>
              <input
                type="text"
                name="number"
                value={formData.number}
                onChange={handleChange}
                placeholder="Phone Number"
                maxLength="10"
              />
            </div>

            <div className="terms">
              <input
                type="checkbox"
                id="terms-agree"
                name="agreed"
                checked={formData.agreed}
                onChange={handleChange}
              />
              <label htmlFor="terms-agree">
                I agree to the <Link to="/terms">Terms of Service</Link>
              </label>
            </div>

            <button className="register-btn" onClick={handleRegister}>
              Login
            </button>
          </div>

          <div className="signin-section image-holder">
            <img src={null} alt="Partner signup illustration" className="partner-illustration" />
          </div>
        </main>

        <section className="stats-section"></section>
        <footer className="footer"></footer>

      </div>
    </div>
  );
};

export default Servicepartner;
